import { DataProvider } from '@cognite/griff-react';
import { useTranslation } from '@infield/features/i18n';
import { createContext } from 'react';

import { useTimeseriesChart } from '../hooks';

export type TrendsChartDependencies = {
  useTranslation: typeof useTranslation;
  useTimeseriesChart: typeof useTimeseriesChart;
  DataProvider: typeof DataProvider;
};

export const defaultDependencies = {
  useTranslation,
  useTimeseriesChart,
  DataProvider,
};

export const TrendsChartContext =
  createContext<TrendsChartDependencies>(defaultDependencies);
